
import React, { useState } from "react";
import { Card, Button, Form, Row, Col, ListGroup, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector } from "react-redux";
import { BillingAPI } from "../../helpers/firebase_helper";

const BillingAlerts = () => {
    const profileData = useSelector((state) => state.Profile.profileData);
    const [emailAlerts, setEmailAlerts] = useState([]);
    const [newEmails, setNewEmails] = useState("");
    const [isEnabled, setIsEnabled] = useState(false); // Toggle for enabling alerts
    const [billingThreshold, setBillingThreshold] = useState("");
    const [currency, setCurrency] = useState(" ");
    const cognitoId = profileData?.result?.cognito_id;

    const handleAddEmail = () => {
        const emailsArray = newEmails.split(",").map(email => email.trim()).filter(email => email);
        const uniqueEmails = [...new Set(emailsArray)]; // Remove duplicates

        uniqueEmails.forEach(email => {
            if (!emailAlerts.includes(email)) {
                setEmailAlerts(prev => [...prev, email]);
            }
        });

        setNewEmails("");
        // console.log("New emails added for alerts:", uniqueEmails);
    };

    const handleRemoveEmail = (emailToRemove) => {
        setEmailAlerts(emailAlerts.filter((email) => email !== emailToRemove));
        // console.log("Email removed from alerts:", emailToRemove);
    };

    const handleSaveAlerts = async() => {

        if (!billingThreshold || emailAlerts.length === 0) {
            toast.error("Please enter a valid billing threshold and at least one email address for alerts.");
            return;
        }

        const payload = {
            cognito_id: cognitoId, // Use actual cognito_id
            email: emailAlerts[0], // Using the first email for the alert
            threshold: parseFloat(billingThreshold), // Convert threshold to number
            threshold_unit: currency
        };
        // console.log(payload);
        
        try{
            const response = await BillingAPI.saveBillingAlert(payload);
            if (response.status === "success") {
                toast.success("Billing alerts saved successfully!");
            } else {
                toast.error("Failed to save billing alerts.");
            }
        }catch (error) {
            console.error("Error saving billing alerts:", error);
            toast.error("An error occurred while saving billing alerts.");
        }
        
    };

    const toggleAlerts = () => {
        setIsEnabled(prev => !prev);
    };

    return (
        <div >
            <Card>
                <Card.Header>
                    <Row className="align-items-center">
                        <Col md={8}>
                            <h3 className="mb-0">Billing Alerts</h3>
                        </Col>
                        <Col md={4} className="text-end">

                            <div className="form-check form-switch form-switch-right form-switch-md me-3">
                                <input
                                    className="form-check-input code-switcher"
                                    type="checkbox"
                                    checked={isEnabled}
                                    onChange={toggleAlerts}
                                />
                            </div>

                        </Col>
                    </Row>
                </Card.Header>
                {isEnabled && (
                    <Card.Body>
                        <Form>

                            <Form.Group className="mb-3" controlId="billingThreshold">
                                <Form.Label>Billing Threshold</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Enter threshold amount"
                                    value={billingThreshold}
                                    onChange={(e) => setBillingThreshold(e.target.value)}
                                />
                                <Form.Text className="text-muted">
                                    Set the billing amount for alerts (e.g., 1000 for $1000).
                                </Form.Text>
                            </Form.Group>

                            {/* Currency Dropdown */}
                            <Form.Group className="mb-3" controlId="currencySelect">
                                <Form.Label>Threshold Unit</Form.Label>
                                <Form.Select value={currency} onChange={(e) => setCurrency(e.target.value)}>
                                    <option value="select">select unit..</option>
                                    <option value="INR">INR</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                    <option value="GBP">GBP</option>

                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>Email Addresses (comma separated)</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter email addresses"
                                    value={newEmails}
                                    onChange={(e) => setNewEmails(e.target.value)}
                                />
                            </Form.Group>

                            <div className="mt-3">
                                <Button variant="primary" onClick={handleAddEmail}>
                                    Add Email
                                </Button>
                            </div>
                        </Form>

                        <h5 className="mt-4">Emails Set for Alerts:</h5>
                        <ListGroup variant="flush">
                            {emailAlerts.map((email, index) => (
                                <ListGroup.Item key={index}>
                                    {email}
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        className="float-end"
                                        onClick={() => handleRemoveEmail(email)}
                                    >
                                        Remove
                                    </Button>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>

                        <div className="mt-3">
                            <Button variant="success" onClick={handleSaveAlerts}>
                                Save Alerts
                            </Button>
                        </div>
                    </Card.Body>
                )}
            </Card>
        </div>
    );
};

export default BillingAlerts;
